import { MENU_DETAIL_HERO_DISPLAY, toThumbUrl } from "@/lib/images";

type MenuImageFields = {
  thumbnail_url?: string | null;
  photo_url?: string | null;
};

function firstNonEmpty(...urls: Array<string | null | undefined>): string | null {
  for (const u of urls) {
    if (typeof u === "string" && u.trim() !== "") return u.trim();
  }
  return null;
}

/** Compact list thumbnails — prefer processed thumb over full capture, then CDN-resize. */
export function getMenuListThumbnail(item: MenuImageFields | null | undefined): string | null {
  const raw = firstNonEmpty(item?.thumbnail_url, item?.photo_url);
  if (!raw) return null;
  return toThumbUrl(raw, { w: 400, q: 72, resize: "contain" }) ?? raw;
}

/**
 * Selected preview / hero — prefer full capture over thumb, then CDN-resize for display.
 * (Do not ship multi‑MB originals into explore drawers / heroes.)
 */
export function getMenuHeroImage(item: MenuImageFields | null | undefined): string | null {
  const raw = firstNonEmpty(item?.photo_url, item?.thumbnail_url);
  if (!raw) return null;
  return toThumbUrl(raw, MENU_DETAIL_HERO_DISPLAY) ?? raw;
}
